import { translateDoctorReviewObject } from '../pages/DoctorReview/doctorReviewTranslator';

const storedAnketasKey = 'medsim-doctor-anketas';

export const caseProfiles = {
  case_002: {
    demographics: {
      sex: 'Female',
      age: '37',
      setting: 'Endocrine clinic',
      background: 'Warehouse assistant, smokes 15 cigarettes/day'
    },
    initialChart: {
      triage: 'Referred with hyperthyroid symptoms and visible neck swelling.',
      disclosedAtStart: [
        'Patient is anxious and worried about choking when swallowing.',
        'Registration note lists palpitations and heat intolerance.',
        'Focused history is required before symptoms are explored in detail.'
      ],
      vitals: ['BP 132/82 mmHg', 'Pulse 60 bpm', 'BMI 32.67 kg/m2']
    },
    labs: {
      Imaging: {
        'Thyroid ultrasound': 'Diffuse multinodular goitre. Nodules appear ultrasonographically benign. No suspicious nodule requiring fine needle aspiration.',
        'Barium swallow': 'Mild cervical esophageal narrowing at thyroid level with no hold-up or obstruction.',
        'Flow-volume loop': 'Mild airflow obstruction, possibly smoking-related. No significant upper airway obstruction.',
        'Pituitary MRI': 'Diffusely abnormal adenohypophysis secondary to a discrete pituitary adenoma.'
      },
      'Dynamic testing': {
        'TRH stimulation test': 'Blunted TSH response, supporting TSH-secreting pituitary adenoma.'
      }
    }
  },
  case_003: {
    demographics: {
      sex: 'Not specified',
      age: '58',
      ethnicity: 'Sri Lankan heritage',
      setting: 'Pre-transplant assessment'
    },
    initialChart: {
      triage: 'Pre-operative optimization before planned liver transplant.',
      disclosedAtStart: [
        'Persistent hyperglycemia and difficult blood pressure control are noted.',
        'Recent confusion and fainting after missed meals require clarification.',
        'Medication reconciliation is an important early task.'
      ],
      vitals: ['BP 158/94 seated, 132/88 standing', 'HR 84 bpm', 'O2 sat 97% RA', 'BMI 27.3 kg/m2']
    },
    labs: {
      Glycemia: {
        'Fasting/postprandial glucose': 'Elevated',
        HbA1c: 'High',
        'Blood glucose': 'Elevated',
        'Genetic testing': 'No monogenic diabetes mutations detected; HNF1A and HNF4A negative.'
      },
      'Liver and renal': {
        AST: 'Elevated',
        ALT: 'Not specified',
        Creatinine: 'Not specified'
      },
      Lipids: {
        'Total cholesterol': 'Elevated',
        Triglycerides: 'Elevated',
        LDL: 'Elevated'
      },
      Imaging: {
        ECG: 'LVH pattern, no acute changes',
        Other: 'Right bundle branch block mentioned by patient; C3bA2 nephropathy noted.'
      }
    }
  },
  case_004: {
    demographics: {
      sex: 'Female',
      age: '25',
      setting: 'Acute medical assessment',
      background: 'Young woman with low BMI'
    },
    initialChart: {
      triage: 'Fatigue, dizziness, weight loss, and recurrent fainting over 2-3 months.',
      disclosedAtStart: [
        'Patient appears pale, withdrawn, and underweight.',
        'Ask targeted questions before assuming endocrine or nutritional causes.',
        'Urine and bedside glucose can be requested from the lab panel.'
      ],
      vitals: ['HR 102 bpm', 'BP 90/50 mmHg', 'Temp 36.0 C', 'Capillary glucose 18.4 mmol/L', 'BMI 16.1 kg/m2']
    },
    labs: {
      Urinalysis: {
        Glucose: '+++',
        Ketones: '++'
      },
      Immunology: {
        'GAD antibodies': 'Positive'
      }
    }
  },
  case_005: {
    demographics: {
      sex: 'Female',
      age: '28',
      ethnicity: 'South Asian',
      setting: 'Community acute clinic'
    },
    initialChart: {
      triage: 'Persistent fatigue, polyuria, polydipsia, and recent weight loss.',
      disclosedAtStart: [
        'Patient is experiencing housing insecurity.',
        'Hydration, nutrition, and access to medication should be explored sensitively.',
        'Urinalysis is available from the lab panel.'
      ],
      vitals: ['Temp 36.7 C', 'HR 92 bpm', 'BP 112/72 mmHg', 'O2 sat 98% RA', 'BMI 33.2']
    },
    labs: {
      Urinalysis: {
        Glucose: '+++',
        Ketones: 'No ketones',
        Protein: 'No protein'
      }
    }
  },
  case_006: {
    demographics: {
      sex: 'Male',
      age: '82',
      ethnicity: 'Egyptian descent',
      setting: 'Renal/endocrine review'
    },
    initialChart: {
      triage: 'Declining eGFR on recent blood tests with fatigue and ankle edema.',
      disclosedAtStart: [
        'Patient appears frail and often speaks through family.',
        'Postural symptoms and medication burden should be checked.',
        'ECG is available in investigations.'
      ],
      vitals: ['BP 132/76 mmHg', 'HR 74 bpm', 'Temp 36.6 C', 'O2 sat 98% RA', 'BMI 19.9 kg/m2']
    },
    labs: {
      Imaging: {
        ECG: 'Normal sinus rhythm with LVH pattern.'
      },
      Examination: {
        'Postural BP': '132/76 to 110/68',
        'Peripheral sensation': 'Decreased in both feet'
      }
    }
  },
  case_007: {
    demographics: {
      sex: 'Мужской',
      age: '20',
      ethnicity: 'Узбек',
      setting: 'Приемное отделение'
    },
    initialChart: {
      triage: 'Частое мочеиспускание, слабость, тошнота, рвота, одышка и похудание за последние недели.',
      disclosedAtStart: [
        'Пациент выглядит обезвоженным, но находится в ясном сознании.',
        'Подробные симптомы нужно выяснять вопросами.',
        'Лабораторные данные доступны через поиск исследований.'
      ],
      vitals: ['АД 100/70 мм рт. ст.', 'ЧСС 120/мин', 'ЧДД 24/мин', 'SpO2 99%', 'Темп. 36,5 C']
    },
    labs: {
      'Анализ мочи': {
        Глюкоза: '1,5',
        Ацетон: 'Положительный (+++ при поступлении)'
      },
      Биохимия: {
        'Капиллярная глюкоза': '20,1 ммоль/л',
        HbA1c: '17,6%',
        pH: '7,14',
        'Анионная разница': '22,0 ммоль/л'
      },
      Электролиты: {
        Калий: '2,9 ммоль/л',
        Натрий: '134 ммоль/л'
      },
      'Почки и печень': {
        Мочевина: '3,4 ммоль/л',
        Креатинин: '59 мкмоль/л',
        АЛТ: '30 ед/л',
        АСТ: '24 ед/л'
      },
      ОАК: {
        Hb: '126 г/л',
        WBC: '14,1 x 10^9/л',
        Тромбоциты: '228 x 10^9/л'
      },
      Инструментальные: {
        ЭКГ: 'Синусовая тахикардия с ЧСС 122/мин, диффузно-дистрофические изменения',
        'Рентген грудной клетки': 'Норма'
      }
    }
  }
};

export const defaultProfile = {
  demographics: {},
  initialChart: {
    triage: 'Patient encounter opened.',
    disclosedAtStart: ['Use focused questions to reveal history and symptoms step by step.'],
    vitals: []
  },
  labs: {}
};

const caseDisplayTranslations = {
  case_002: {
    ru: { name: 'Пациентка', chiefComplaint: 'Симптомы, характерные для гипертиреоза', triage: 'Направлена с симптомами гипертиреоза и заметным увеличением шеи.', sex: 'женский', setting: 'Эндокринологическая клиника' },
    uz: { name: 'Ayol bemor', chiefComplaint: 'Gipertireozga xos belgilar', triage: 'Gipertireoz belgilari va bo‘yinda ko‘rinadigan shish bilan yuborilgan.', sex: 'ayol', setting: 'Endokrinologiya klinikasi' }
  },
  case_003: {
    ru: { name: 'Пациент шри-ланкийского происхождения', chiefComplaint: 'Предоперационная подготовка к плановой трансплантации печени: стойкая гипергликемия, трудно контролируемая артериальная гипертензия и недавние эпизоды спутанности сознания', triage: 'Предоперационная оптимизация перед плановой трансплантацией печени.', sex: 'не указано', setting: 'Предтрансплантационная оценка' },
    uz: { name: 'Shri-Lanka millatiga mansub bemor', chiefComplaint: 'Rejalashtirilgan jigar transplantatsiyasi oldidan tayyorgarlik: turg‘un giperglikemiya, nazorat qilish qiyin bo‘lgan arterial gipertenziya va yaqinda kuzatilgan ong chalkashishi holatlari', triage: 'Rejalashtirilgan jigar transplantatsiyasi oldidan operatsiyaga tayyorlash.', sex: 'ko‘rsatilmagan', setting: 'Transplantatsiya oldi baholash' }
  },
  case_004: {
    ru: { name: 'Молодая пациентка', chiefComplaint: 'Утомляемость, головокружение, снижение массы тела и повторные обмороки в течение последних 2-3 месяцев', triage: 'Утомляемость, головокружение, снижение массы тела и повторные обмороки в течение 2-3 месяцев.', sex: 'женский', setting: 'Острое медицинское обследование' },
    uz: { name: 'Yosh ayol bemor', chiefComplaint: 'So‘nggi 2-3 oy davomida charchoq, bosh aylanishi, vazn yo‘qotish va takroriy hushdan ketish holatlari', triage: '2-3 oy davomida charchoq, bosh aylanishi, vazn yo‘qotish va takroriy hushdan ketish.', sex: 'ayol', setting: 'Shoshilinch tibbiy baholash' }
  },
  case_005: {
    ru: { name: 'Бездомная пациентка южноазиатского происхождения', chiefComplaint: 'Постоянная утомляемость, полиурия, полидипсия и недавнее снижение массы тела', triage: 'Постоянная утомляемость, полиурия, полидипсия и недавнее снижение массы тела.', sex: 'женский', setting: 'Общественная клиника неотложной помощи' },
    uz: { name: 'Janubiy osiyolik, boshpanasiz ayol bemor', chiefComplaint: 'Doimiy charchoq, poliuriya, polidipsiya va yaqinda vazn yo‘qotish', triage: 'Doimiy charchoq, poliuriya, polidipsiya va yaqinda vazn yo‘qotish.', sex: 'ayol', setting: 'Mahalla shoshilinch klinikasi' }
  },
  case_006: {
    ru: { name: 'Пациент египетского происхождения', chiefComplaint: 'Снижение расчётной СКФ по последним анализам крови, утомляемость и отёки в области лодыжек', triage: 'Снижение расчётной СКФ по недавним анализам крови, утомляемость и отёки лодыжек.', sex: 'мужской', setting: 'Нефроэндокринологический осмотр' },
    uz: { name: 'Misrlik bemor', chiefComplaint: 'So‘nggi qon tahlillarida hisoblangan KFT pasayishi, charchoq va to‘piq sohasida shish', triage: 'Yaqindagi qon tahlillarida hisoblangan KFT pasayishi, charchoq va to‘piq shishi.', sex: 'erkak', setting: 'Buyrak/endokrinologik ko‘rik' }
  },
  case_007: {
    en: { name: 'Jasur Omonov', chiefComplaint: 'Frequent urination, palpitations, generalized weakness, headache, nausea, repeated vomiting, shortness of breath, and weight loss over recent weeks', triage: 'Frequent urination, weakness, nausea, vomiting, shortness of breath, and weight loss over recent weeks.', sex: 'male', setting: 'Emergency department' },
    ru: { name: 'Жасур Омонов', chiefComplaint: 'Частое мочеиспускание, сердцебиение, общая слабость, головная боль, тошнота, многократная рвота, одышка и снижение массы тела в течение последних недель', triage: 'Частое мочеиспускание, слабость, тошнота, рвота, одышка и снижение массы тела за последние недели.', sex: 'мужской', setting: 'Приёмное отделение' },
    uz: { name: 'Jasur Omonov', chiefComplaint: 'So‘nggi haftalarda tez-tez siyish, yurak urib ketishi, umumiy holsizlik, bosh og‘rig‘i, ko‘ngil aynishi, takroriy qusish, nafas qisishi va vazn yo‘qotish', triage: 'So‘nggi haftalarda tez-tez siyish, holsizlik, ko‘ngil aynishi, qusish, nafas qisishi va vazn yo‘qotish.', sex: 'erkak', setting: 'Qabul bo‘limi' }
  }
};

export function getLocalizedCaseDisplay(caseItem, language = 'en') {
  if (!caseItem) return null;
  const localized = caseDisplayTranslations[caseItem.id]?.[language] || {};
  return {
    ...caseItem,
    name: localized.name || caseItem.name,
    chiefComplaint: localized.chiefComplaint || caseItem.chiefComplaint,
    triage: localized.triage,
    gender: localized.sex || caseItem.gender,
    setting: localized.setting || caseItem.setting
  };
}

export function getStoredAnketas() {
  try {
    return JSON.parse(localStorage.getItem(storedAnketasKey) || '{}');
  } catch {
    return {};
  }
}

export function saveStoredAnketa(caseId, anketa) {
  const existing = getStoredAnketas();
  localStorage.setItem(storedAnketasKey, JSON.stringify({
    ...existing,
    [caseId]: {
      ...anketa,
      updatedAt: new Date().toISOString()
    }
  }));
}

export function getCaseProfile(caseItem, language = 'en') {
  if (!caseItem) return defaultProfile;
  const stored = getStoredAnketas()[caseItem.id];
  const base = caseProfiles[caseItem.id] || defaultProfile;

  const rawProfile = !stored ? base : {
    ...base,
    demographics: {
      ...base.demographics,
      sex: stored.sex || base.demographics.sex,
      age: stored.age || base.demographics.age,
      ethnicity: stored.ethnicity || base.demographics.ethnicity,
      setting: stored.setting || base.demographics.setting
    },
    initialChart: {
      triage: stored.triage || base.initialChart.triage,
      disclosedAtStart: stored.initialNotes
        ? stored.initialNotes.split('\n').filter(Boolean)
        : base.initialChart.disclosedAtStart,
      vitals: stored.vitals
        ? stored.vitals.split('\n').filter(Boolean)
        : base.initialChart.vitals
    },
    labs: stored.labs ? parseLooseKeyValueGroups(stored.labs) : base.labs
  };

  if (language !== 'en') {
    return translateDoctorReviewObject(rawProfile, language);
  }

  return rawProfile;
}

function parseLooseKeyValueGroups(text) {
  const groups = {};
  let activeGroup = 'Doctor-entered results';

  text.split('\n').forEach((rawLine) => {
    const line = rawLine.trim();
    if (!line) return;
    if (line.endsWith(':') && !line.includes('=')) {
      activeGroup = line.slice(0, -1);
      groups[activeGroup] = groups[activeGroup] || {};
      return;
    }
    const [name, ...rest] = line.split(/:|=/);
    groups[activeGroup] = groups[activeGroup] || {};
    groups[activeGroup][name.trim()] = rest.join(':').trim() || 'Available';
  });

  return groups;
}
